<div class="content">
  <div class="modal-header">
    <h4 class="modal-title full-width ">
      <span>{{ 'LABELS.PLEASE_ENTER_YOUR_CVV_TO_PROCEED' | translate}}</span>
    </h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col">
        <div>
          <form #cvvForm="ngForm">
            <input class="form-control" placeholder="CVV" maxlength="4" minlength="3" required appNumberOnly
              type="password" name="cardCVV2" [(ngModel)]="cardCVV2" />
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="button-list">
      <button type="button" class="btn btn-sm fis-btn" (click)="activeModal?.close(null)">{{ 'LABELS.CLOSE' | translate}}
      </button>
      <button type="button" class="btn btn-sm fis-btn" [disabled]="loading || !cardCVV2 || cardCVV2.length < 3"
        (click)="doPayment()"> {{ 'LABELS.DONE' | translate}}
      </button>
    </div>
  </div>
  <div class="card-disabled" *ngIf="loading">
    <div class="card-portlets-loader">
      <div class="spinner-border text-primary m-2" role="status"></div>
    </div>
  </div>
</div>
